import { differenceInYears, parse } from 'date-fns';

import { formatDate } from './formatDate';

export const calculateAge = (dob: string) => {
  const date = parse(formatDate(dob, 'dd/MM/yyyy'), 'dd/MM/yyyy', new Date());
  const age = differenceInYears(new Date(), date);

  return age;
};
